import {
  ApiData,
  ApiErrorReasonType,
  InsuranceName,
  YesNoAnswer,
} from 'scenes/common/types';
import {
  BRAND,
  REQUEST_VERSION,
  WireChannel,
  WireFlybuys,
  WirePortfolio,
  WireProduct,
  WireStatus,
  WireTransactionType,
} from 'scenes/common/api/quote/types';
import { makeBusinessError } from 'scenes/common/helpers/apiData';
import { getConfirmAndPayMetadata } from './metadata';

export const unmarshalQuoteErrorResponse = <T>(
  reason: ApiErrorReasonType,
  quoteNumber: string,
  blocking?: boolean,
  stage?: string
): ApiData<T> => makeBusinessError(reason, quoteNumber, blocking, stage);

export const requestDefaults = (product: WireProduct) => ({
  brand: BRAND,
  product,
  version: REQUEST_VERSION,
  transactionType: WireTransactionType.Quote,
  targetStatus: WireStatus.ExactQuote,
  portfolio: WirePortfolio.ColesCp,
  channel: WireChannel.Web,
  metaData: [],
});

export const requestBindDefaults = (product: WireProduct) => ({
  brand: BRAND,
  product,
  version: REQUEST_VERSION,
  transactionType: WireTransactionType.Quote,
  targetStatus: WireStatus.BindQuote,
  portfolio: WirePortfolio.ColesCp,
  channel: WireChannel.Web,
  metaData: getConfirmAndPayMetadata(),
});

export const toWireFlybuys = (
  isFlybuysMember: boolean,
  flybuysNumber: string = ''
) =>
  isFlybuysMember
    ? {
        isSignUp: false,
        flybuysNumber,
        latestConsent: false,
      }
    : { isSignUp: false, flybuysNumber: '' };

export const toHasFlybuys = (flybuys: WireFlybuys | undefined): YesNoAnswer =>
  flybuys?.flybuysNumber ? YesNoAnswer.Yes : YesNoAnswer.No;

export const toFlybuysNumber = (flybuys: WireFlybuys | undefined): string =>
  flybuys?.flybuysNumber ?? '';

export const wireProduct: {
  [key in InsuranceName]: WireProduct;
} = {
  [InsuranceName.Car]: WireProduct.Motor,
  [InsuranceName.Home]: WireProduct.Home,
  [InsuranceName.Landlord]: WireProduct.Landlord,
};
